import _ from 'lodash'
import ObjectID from 'bson-objectid'

/**
 * Checklist items need a persisted `_id` before their first save because
 * visibility rules reference their trigger question by id. Generated ids are
 * kept by the checklist payload and by backend duplication, so rules keep
 * pointing at the right question. Mirrors optionIds.js for options.
 */
export function createItemId() {
  return ObjectID().toHexString()
}

export function ensureItemIds(items = [], { forceNew = false } = {}) {
  return (_.isArray(items) ? items : []).map(item => ({
    ...item,
    _id: getItemId(item, forceNew),
  }))
}

function getItemId(item, forceNew) {
  if (forceNew || !item?._id) {
    return createItemId()
  }

  return item._id
}
